<div class="position-relative d-flex flex-column h-100  text-grey"
cdkDrag cdkDragRootElement=".cdk-overlay-pane"
cdkDragBoundary="body"
[cdkDragDisabled]="!toogleDialog">
<div class="modal-header jobDialogHeader text-grey" cdkDragHandle>
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Add Image
  </h4>
  <i
  style="z-index: 1"
  class="bi bi-dash text-danger"
  [ngClass]="{
    'bi-dash-lg': !toogleDialog,
    'bi-fullscreen': toogleDialog,
    'minmax-dialog': toogleDialog
  }"
  color="warn"
  (click)="toogleDialogMinMax()"
  [title]="toogleDialog ? 'Maximize' : 'Minimize'"
  ></i>
  <i
  style="z-index: 1"
  class="bi bi-x-lg text-danger mx-3"
  color="warn"
  (click)="onCancel()"
  title="Close"
  ></i>
</div>
<div class="modal-body jobDialogBody text-grey">
  <form
    name="buildAndPushImageFormVar"
    [formGroup]="buildAndPushImageFormVar"
    autocomplete="off"
    spellcheck="false"
  >
  <div class="h-100 d-flex flex-column">
    <div class="flex-grow-1">
      <div class="form-row">
        <div class="form-col">
          <mat-form-field >
            <mat-label>Image Name</mat-label>
            <input
            matInput
            maxlength="36"
            placeholder="Image Name"
            formControlName="image_name"
            />
            <mat-error
              *ngIf="buildAndPushImageFormVar.get('image_name')?.hasError('required') && buildAndPushImageFormVar.get('image_name')?.touched">
              Image name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-col">
          <mat-form-field >
            <mat-label>Tag</mat-label>
            <input
            matInput
            maxlength="20"
            placeholder="Tag"
            formControlName="tag"
            />
            <mat-error
              *ngIf="buildAndPushImageFormVar.get('tag')?.hasError('required') && buildAndPushImageFormVar.get('tag')?.touched">
              Tag is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <!-- <div class="form-row" style="margin-bottom: 2px;">
        <mat-checkbox
          formControlName="auto_push"
          class="well well-sm text-primary"
          style="margin-left: 2px;"
          >
          Auto Push to Registry
        </mat-checkbox>
    </div> -->
    <!-- <div class="form-row">
      <div class="form-col">
        <mat-form-field >
          <mat-label>Registry Host</mat-label>
          <input
          matInput
          maxlength="36"
          placeholder="Registry Host"
          formControlName="registry_host"
          />
          <mat-error
            *ngIf="buildAndPushImageFormVar.get('registry_host')?.hasError('required') && buildAndPushImageFormVar.get('registry_host')?.touched">
            Registry Host is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-col">
        <mat-form-field >
          <mat-label>Repository Name</mat-label>
          <input
          matInput
          maxlength="20"
          placeholder="Repository Name"
          formControlName="repository_name"
          />
          <mat-error
            *ngIf="buildAndPushImageFormVar.get('repository_name')?.hasError('required') && buildAndPushImageFormVar.get('repository_name')?.touched">
            Repository Name is required
          </mat-error>
        </mat-form-field>
      </div>
    </div> -->
    <p>Dockerfile Content *</p>
    <p style="margin-bottom: 0px">
      <mat-form-field style="width: 100%">
        <textarea
        matInput
        placeholder="Dockerfile Content"
        formControlName="dockerfile_content"
        rows="6"
        style="
        width: 100%;
        max-width: 100%;
        height: 103px;
        font-size: smaller;
        "
        class="form-control dockerfile-editor"
        ></textarea>
          <mat-error
            *ngIf="buildAndPushImageFormVar.get('dockerfile_content')?.hasError('required') && buildAndPushImageFormVar.get('dockerfile_content')?.touched">
            Dockerfile Content is required
          </mat-error>
      </mat-form-field>
    </p>
    
  </div>
</div>
</form>
  
</div>
<div class="modal-footer jobDialogFooter text-grey">
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex d-flex justify-content-end w-100">
      <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="onCancel()"
      >
      Close
    </button>
    <button
    type="button"
    class="btn btn-primary ms-2"
    (click)="createImage()"
    >
    Submit
  </button>
</div>
</div>
</div>
<ngx-spinner
bdColor="rgba(0,0,0,0)"
size="default"
zIndex="1"
color="var(--s-primary-color)"
type="ball-spin"
[fullScreen]="false"
>
<p class="pleaseWait text-grey">Please wait ...</p>
</ngx-spinner>
</div>
